import * as React from 'react';
import { TApplicationState } from '../../models/application-state';

import { TUser } from '../../models/user.model';
import { APP_ADVISOR, APP_APPLICATION_STATE, APP_SPINNER } from './app.constant';
import { appContextReducer, AppContextState, initialState } from './app.context.reducer';

type AppProviderProps = { children: React.ReactNode };

const AppStateContext = React.createContext<AppContextState>(initialState);
AppStateContext.displayName = 'AppContext';

function AppContextProvider({ children }: AppProviderProps) {
	const [state, dispatch] = React.useReducer(appContextReducer, initialState);

	const loadUser = (user: TUser) => dispatch({ type: APP_ADVISOR, payload: user });
	const loadApplicationState = (appState: TApplicationState) => dispatch({ type: APP_APPLICATION_STATE, payload: appState });
	const setShowSpinner = (show: boolean) => dispatch({ type: APP_SPINNER, payload: show });
	const values = React.useMemo(() => ({ ...state, loadUser, loadApplicationState, setShowSpinner }), [state]);

	return <AppStateContext.Provider value={{ ...values }}>{children}</AppStateContext.Provider>;
}

function useApp() {
	const context = React.useContext(AppStateContext);
	if (context === undefined) {
		throw new Error('useApp must be used within a AppContextprovider');
	}
	return context;
}

export { AppContextProvider, useApp };
